import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import StudentsSelector from 'modules/students/components/StudentsSelector';
import CourseSelector from 'modules/courses/components/CourseSelector';

const useStyles = makeStyles((theme) => ({
  courseSelector: {
    marginBottom: theme.spacing(2),
  },
}));

const ImportStudentsFromCourseForm = (props) => {
  const classes = useStyles();
  const { studentsSelectorProps, courseSelectorProps, showKeepGroupsCheckbox, keepGroups, onToggleKeepGroups } = props;

  return (
    <Box width="100%">
      <CourseSelector {...courseSelectorProps} className={classes.courseSelector} />
      {showKeepGroupsCheckbox && (
        <FormControlLabel
          classes={{ root: classes.selectAllCheckbox }}
          control={<Checkbox checked={keepGroups} onChange={onToggleKeepGroups} color="secondary" />}
          label={<FormattedMessage id="students.importStudentsFromCourse.keepGroups" />}
        />
      )}
      <StudentsSelector {...studentsSelectorProps} />
    </Box>
  );
};

ImportStudentsFromCourseForm.propTypes = {
  showKeepGroupsCheckbox: PropTypes.bool,
  keepGroups: PropTypes.bool,
  onToggleKeepGroups: PropTypes.func,

  studentsSelectorProps: PropTypes.object.isRequired,
  courseSelectorProps: PropTypes.object.isRequired,
};

ImportStudentsFromCourseForm.defaultProps = {
  showKeepGroupsCheckbox: false,
  keepGroups: false,
  onToggleKeepGroups: undefined,
};

export default ImportStudentsFromCourseForm;
